import { InjectionToken, Signal } from '@angular/core';

export interface AppIdentity {
  username: string;
  roles: string[];
  firstName: string;
  lastName: string;
  email: string;
}

export const IDENTITY_SIGNAL = new InjectionToken<Signal<AppIdentity | null>>(
  'APP_IDENTITY_SIGNAL',
);
